var _dec, _class, _class2, _temp;
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import * as React from 'react';
import injectStyles from '4finance-components';
import translate from '4finance-translate';
import styles from './UserLockdown.jss';
var InfoIcon = function InfoIcon(props) {
  return React.createElement("svg", props, React.createElement("g", {
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M4.699 73.332l19.554-6.345a1.5 1.5 0 0 1 1.142.09 33.5 33.5 0 0 0 15.217 3.627c18.533 0 33.555-14.97 33.555-33.435 0-18.465-15.022-33.436-33.555-33.436S7.058 18.803 7.058 37.27a33.186 33.186 0 0 0 3.829 15.525 1.5 1.5 0 0 1 .1 1.163L4.698 73.332zm-1.872 3.761c-1.165.379-2.267-.724-1.89-1.89L7.94 53.627a36.19 36.19 0 0 1-3.882-16.357C4.058 17.145 20.425.833 40.612.833S77.167 17.145 77.167 37.27c0 20.123-16.368 36.435-36.555 36.435a36.51 36.51 0 0 1-16.016-3.675L2.827 77.093z",
    fillRule: "nonzero"
  }), React.createElement("path", {
    d: "M42.386 44.28h-3.068c-.624 0-.832-.312-.884-.936l-.832-16.536v-8.476c0-.52.26-.832.78-.832h4.94c.52 0 .78.312.78.832v8.476l-.832 16.536c-.052.624-.26.936-.884.936zm-4.836 4.316v-.624c0-.52.208-.78.78-.78h4.992c.52 0 .78.26.78.78v5.2c0 .468-.26.728-.728.728H39.37c-.624 0-.988-.208-1.196-.884-.312-1.04-.624-2.912-.624-4.42z"
  })));
};
InfoIcon.defaultProps = {
  viewBox: "0 0 78 78",
  xmlns: "http://www.w3.org/2000/svg"
}; // eslint-disable-line import/namespace, import/default

var PhoneIcon = function PhoneIcon(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M5.067 8.233c1.545 3.01 2.56 4.293 5.7 5.7l1.9-1.266c.244-.558.697-.648 1.266-.634 1.111.528 2.493.754 3.8.634.757.12 1.267.623 1.267 1.266v3.8c0 .764-.51 1.267-1.267 1.267C7.086 19 0 11.737 0 1.267 0 .503.516 0 1.267 0h3.8c.73 0 1.24.503 1.266 1.267-.026 1.269.203 2.63.634 3.8.12.485.028.931 0 1.266l-1.9 1.9z",
    fillRule: "evenodd"
  }));
};
PhoneIcon.defaultProps = {
  viewBox: "0 0 19 19",
  xmlns: "http://www.w3.org/2000/svg"
}; // eslint-disable-line import/namespace, import/default

var EmailIcon = function EmailIcon(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M20.774 4.842l-9.274 5.76-9.274-5.76v-2.16l9.274 5.76 9.274-5.76v2.16zm0-4.842H2.226C1.029 0 .011 1.007 0 2.16v13.68C0 16.993 1.029 18 2.226 18h18.548C21.971 18 23 16.993 23 15.84V2.16C23 1.007 21.971 0 20.774 0z",
    fillRule: "evenodd"
  }));
};
EmailIcon.defaultProps = {
  viewBox: "0 0 23 18",
  xmlns: "http://www.w3.org/2000/svg"
}; // eslint-disable-line import/namespace, import/default

var ChatIcon = function ChatIcon(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M3 5h15V3H3v2zm0 8h7v-2H3v2zm0-4h15V7H3v2zM1.826 0C.94 0 .01.94 0 1.826V21l3.652-3.652h15.522C20.06 16.8 21 15.86 21 14.608V1.827C21 .94 20.06 0 19.174 0H1.826z",
    fillRule: "evenodd"
  }));
};
ChatIcon.defaultProps = {
  viewBox: "0 0 21 21",
  xmlns: "http://www.w3.org/2000/svg"
}; // eslint-disable-line import/namespace, import/default

var UserLockdown = (_dec = injectStyles(styles), translate(_class = _dec(_class = (_temp = _class2 = /*#__PURE__*/
function (_React$PureComponent) {
  _inherits(UserLockdown, _React$PureComponent);
  function UserLockdown() {
    _classCallCheck(this, UserLockdown);
    return _possibleConstructorReturn(this, _getPrototypeOf(UserLockdown).apply(this, arguments));
  }
  _createClass(UserLockdown, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        cnt = _this$props.cnt,
        msg = _this$props.msg,
        hideChatIcon = _this$props.hideChatIcon;
      return React.createElement("div", {
        className: classes.container
      }, React.createElement("div", {
        className: classes.icon
      }, React.createElement(InfoIcon, null)), React.createElement("p", {
        className: classes.heading
      }, cnt('lockdown.message')), React.createElement("hr", null), React.createElement("div", {
        className: classes.contact,
        "data-test": "contact-by-phone"
      }, React.createElement("div", {
        className: classes.contactIcon
      }, React.createElement(PhoneIcon, null)), React.createElement("div", {
        className: classes.contactLink
      }, msg('lockdown.phone'))), React.createElement("div", {
        className: classes.contact,
        "data-test": "contact-by-email"
      }, React.createElement("div", {
        className: classes.contactIcon
      }, React.createElement(EmailIcon, null)), React.createElement("div", {
        className: classes.contactLink
      }, msg('lockdown.email'))), !hideChatIcon && React.createElement("div", {
        className: classes.contact,
        "data-test": "contact-by-chat"
      }, React.createElement("div", {
        className: classes.contactIcon
      }, React.createElement(ChatIcon, null)), React.createElement("div", {
        className: classes.contactLink
      }, msg('lockdown.chat'))), React.createElement("hr", null), React.createElement("p", {
        className: classes.workingHours,
        "data-test": "contact-workinghours"
      }, cnt('lockdown.workingHours')));
    }
  }]);
  return UserLockdown;
}(React.PureComponent), _defineProperty(_class2, "styleRoot", 'UserLockdown'), _defineProperty(_class2, "defaultProps", {
  errorCode: '',
  classes: {},
  cnt: function cnt() {
    return '';
  },
  msg: function msg() {
    return '';
  }
}), _temp)) || _class) || _class);
export { UserLockdown as default };